// import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

import { getCurrentScriptParams } from '../host/getCurrentScriptParams.tsx';
import { getHostNode, getHostNodes } from '../host/getHostNode.tsx';
import { getNodes } from '../host/getNodes.tsx';
import { getPropsByPluginType } from '../host/props/getPropsByPluginType.ts';
import OrderRoot from '../order/OrderRoot.tsx';
import PluginRoot from '../plugin/PluginRoot.tsx';

// eslint-disable-next-line
import { createRoot } from 'react-dom/client';
import type { PLUGIN_TYPE_ENUM } from '../PluginType.ts';
import { PLUGIN_TYPE } from '../PluginType.ts';
import { WooviPayButtonRoot } from '../woovipay/WooviPayButtonRoot.tsx';

// const pluginPrefix = 'openpix-order';

// // call this function at the root of the application and before any MUI components import
// ClassNameGenerator.configure((componentName) => {
//   return `${pluginPrefix}-${componentName}`;
// });

export const pluginInit = () => {
  // get global params
  const scriptParams = getCurrentScriptParams();

  const nodesWithConfig = getNodes(scriptParams.node, scriptParams);

  if (nodesWithConfig.length === 0) {
    if (scriptParams.correlationID || scriptParams.paymentLinkID) {
      const hostNodes = getHostNodes();

      for (const hostNode of hostNodes) {
        const orderProps = {
          correlationID: scriptParams.correlationID,
          paymentLinkID: scriptParams.paymentLinkID,
          appID: scriptParams.appID,
          isTemp: !!scriptParams?.isTemp,
        };

        const root = createRoot(hostNode);

        root.render(<OrderRoot {...orderProps} />);
      }

      return;
    }

    const hostNode = getHostNode();

    const root = createRoot(hostNode);

    root.render(<PluginRoot />);

    return;
  }

  for (const nodeWithConfig of nodesWithConfig) {
    const { node, pluginType } = nodeWithConfig;

    const params = {
      correlationID:
        nodeWithConfig.params.correlationID || scriptParams.correlationID,
      paymentLinkID:
        nodeWithConfig.params.paymentLinkID || scriptParams.paymentLinkID,
      appID: nodeWithConfig.params.appID || scriptParams.appID,
      value: nodeWithConfig.params.value || scriptParams.value,
      isTemp: !!nodeWithConfig.params.isTemp || !!scriptParams.isTemp,
      redirectUrl:
        nodeWithConfig.params.redirectUrl || scriptParams.redirectUrl,
    };

    if (!pluginType) {
      if (params.correlationID || params.paymentLinkID) {
        const root = createRoot(node);

        root.render(<OrderRoot {...params} />);

        return;
      }

      const root = createRoot(node);

      root.render(<PluginRoot />);

      return;
    }

    const pluginPropsGetResult = getPropsByPluginType({
      pluginType: pluginType as PLUGIN_TYPE_ENUM,
      params: nodeWithConfig.params,
    });

    const componentByPluginType = {
      [PLUGIN_TYPE.ORDER]: OrderRoot,
      [PLUGIN_TYPE.BUTTON]: WooviPayButtonRoot,
      [PLUGIN_TYPE.PLUGIN]: PluginRoot,
    };

    const AppRoot = componentByPluginType[pluginType];

    const root = createRoot(node);

    if (pluginType === PLUGIN_TYPE.BUTTON) {
      if (!pluginPropsGetResult.success) {
        //eslint-disable-next-line
        console.error(pluginPropsGetResult.error);

        continue;
      }

      root.render(<AppRoot {...pluginPropsGetResult.props} />);

      continue;
    }

    root.render(<AppRoot {...params} />);
  }
};
